<section class="page-container bg-primary">

    <div class="container h-100">

        <div class="row h-100 d-flex justify-content-center align-items-center">

            <div class="col-md-8">

                <a class="btn btn-link text-white ml-1 pb-4" [routerLink]="[ data.URL_LOGIN ] | localize"><i
                        class="fas fa-arrow-left fa-2x"></i></a>

                <nav class="navbar navbar-dark bg-primary">

                    <a class="navbar-brand d-flex align-items-center" [routerLink]="[ data.URL_HOME ] | localize">
                        <img class="logo" src="./assets/imagens/logo_branca.png">
                    </a>

                    <div id="navbarNav" class="d-flex justify-content-end">

                        <ul>
                            <li class="drop-down">
                                <a><i class="flag-icon {{ idiomaSelecionado.FLAG }} mr-lg-2"></i><span
                                        class="d-none d-lg-inline">{{ idiomaSelecionado.TITULO }}</span><i
                                        class="fas fa-angle-down ml-2"></i></a>
                                <ul>
                                    <li *ngFor="let idioma of idiomas">
                                        <a *ngIf="idiomaSelecionado.CODIGO != idioma.CODIGO" (click)="alterarIdioma(idioma.CODIGO)"><i
                                                class="flag-icon {{ idioma.FLAG }} mr-2"></i>{{ idioma.TITULO }}</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>

                    </div>

                </nav>

                <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">

                    <div class="col-md-12 mt-4">

                        <h3 class="text-white"> {{ data.TITLE }} </h3>
                        <p class="text-white"> {{ data.DESCRICAO }} </p>

                        <div class="control-group mb-2">

                            <div class="form-group">

                                <label class="text-white control-label">{{ data.CAMPO_EMPRESA }} <span
                                        class="text-warning">*</span></label>
                                <div class="input-group mb-0">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-building"></i></span>
                                    </div>
                                    <input type="text" class="form-control" name="nomeEmpresa"
                                        formControlName="formNomeEmpresa">
                                </div>

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.NOME_EMPRESA">
                                    <span class="text-warning"
                                        *ngIf="formGroup.get('formNomeEmpresa').hasError(validator.TYPE) && (formGroup.get('formNomeEmpresa').dirty || formGroup.get('formNomeEmpresa').touched) ">{{ validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>

                        </div>

                        <div class="control-group mb-2">

                            <div class="form-group">

                                <label class="text-white control-label">{{ data.CAMPO_USUARIO }} <span
                                        class="text-warning">*</span></label>
                                <div class="input-group mb-0">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-user"></i></span>
                                    </div>
                                    <input type="text" class="form-control" name="usuario"
                                        formControlName="formUsuario">
                                </div>

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.USUARIO">
                                    <span class="text-warning"
                                        *ngIf="formGroup.get('formUsuario').hasError(validator.TYPE) && (formGroup.get('formUsuario').dirty || formGroup.get('formUsuario').touched) ">{{ validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>

                        </div>

                        <div class="control-group mb-4">

                            <div class="form-group">

                                <label class="text-white control-label">{{ data.CAMPO_EMAIL }} <span
                                        class="text-warning">*</span></label>
                                <div class="input-group mb-0">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                                    </div>
                                    <input type="email" class="form-control" name="email" formControlName="formEmail">
                                </div>

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.EMAIL">
                                    <span class="text-warning"
                                        *ngIf="formGroup.get('formEmail').hasError(validator.TYPE) && (formGroup.get('formEmail').dirty || formGroup.get('formEmail').touched) ">{{ validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>

                        </div>

                        <div class="form-group">
                            <button class="btn btn-info rounded-0 w-100" [disabled]="!formGroup.valid">
                                {{ data.BOTAO }}
                            </button>
                        </div>

                    </div>

                </form>

            </div>

        </div>

    </div>

</section>